import { render, staticRenderFns } from "./securityawareness.vue?vue&type=template&id=aac15496&"
import script from "./securityawareness.vue?vue&type=script&lang=js&"
export * from "./securityawareness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports